import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const NotFound = () => {
  const { t } = useTranslation('page');

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
      <div className="text-center" style={{ maxWidth: '500px' }}>
        <div className="mb-4">
          <i className="fa-regular fa-circle-question" style={{ fontSize: '3rem', color: '#adb5bd' }} />
        </div>

        <h2 className="mb-3">{t('not-found.header')}</h2>

        <p className="text-muted mb-4">{t('not-found.info')}</p>

        <div className="d-flex justify-content-center gap-2">
          <Link to="/" className="btn btn-primary">
            {t('not-found.go.home')}
          </Link>
        </div>
      </div>
    </div>
  );
};
